import { useState, useEffect } from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_site-creator-2145/artifacts/d1n4bcn4_13880.jpg";

export default function Welcome({ onEnter }) {
  const [phase, setPhase] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 400);
    const t2 = setTimeout(() => handleEnter(), 4500);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  const handleEnter = () => {
    if (phase === 2) return;
    setPhase(2);
    setTimeout(() => { setVisible(false); onEnter(); }, 1200);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="welcome-screen"
      onClick={handleEnter}
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center cursor-pointer"
      style={{
        background: '#000',
        opacity: phase === 2 ? 0 : 1,
        transition: 'opacity 1.2s ease-in-out',
      }}
    >
      {/* Soft gold radial glow */}
      <div
        className="absolute rounded-full"
        style={{
          width: phase >= 1 ? '500px' : '0px',
          height: phase >= 1 ? '500px' : '0px',
          background: 'radial-gradient(circle, rgba(201,168,76,0.07) 0%, transparent 70%)',
          transition: 'all 2.5s ease-out',
        }}
      />

      {/* Logo — dissolve in from transparent */}
      <div className="relative z-10 flex flex-col items-center">
        <img
          src={LOGO_URL}
          alt="Chef Compliance UK"
          data-testid="welcome-logo"
          className="w-64 h-64 md:w-80 md:h-80 object-contain"
          style={{
            opacity: phase >= 1 ? 1 : 0,
            filter: phase >= 1
              ? 'blur(0px) brightness(1) drop-shadow(0 0 30px rgba(201,168,76,0.25))'
              : 'blur(12px) brightness(1.6)',
            transform: phase >= 1 ? 'scale(1)' : 'scale(1.08)',
            transition: 'opacity 1.8s ease-out, filter 2s ease-out, transform 2s ease-out',
          }}
        />

        <p
          className="mt-6 text-[10px] text-zinc-600 uppercase tracking-[0.3em]"
          style={{
            opacity: phase >= 1 ? 1 : 0,
            transition: 'opacity 0.8s ease 1.8s',
          }}
        >
          Click anywhere to enter
        </p>
      </div>

      {/* Powered by */}
      <div
        className="absolute bottom-6 left-0 right-0 text-center"
        style={{
          opacity: phase >= 1 ? 1 : 0,
          transition: 'opacity 0.6s ease 2.2s',
        }}
      >
        <p className="text-[10px] text-zinc-600 tracking-wider">
          Powered by <a href="https://www.jrtchidememedia.co.uk" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline">JRT Chideme Media</a>
        </p>
      </div>
    </div>
  );
}
